export default {
	// 开启命名空间
	namespaced:true,
	actions:{
 
	},
	mutations:{
    // 切换middle页面
    changeComponentName(state, comName) {
      state.componentName = comName;
    },
		// 切换色调
		changeIsDark(state, val) {
			state.isDark = val;
		},
		// 切换引导页展示
		changeIsShowHint(state, val) {
			state.isShowHint = val;
		},
	},
	state:{
    componentName: 'ChatHistory',  // middle组件名
		isDark: false, // 是否暗黑主题
		isShowHint: false, // 是否展示引导页
	},
	getters:{
	},
}